/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@/assets/css/styles.css'; // extends

const Carousel = (props) => {
  const { children, innerRef = () => {} } = props;
  return (
    <Slider {...props} adaptiveHeight ref={(slider) => innerRef(slider)}>
      {children}
    </Slider>
  );
};

export default Carousel;
